module.exports = __webpack_public_path__ + "static/media/icon-social-shares.cc6b5095.svg";